<template>
    <div class="t-form-comment">
        <transition name="fadeRight">
            <success-cmp v-if="infoForm.success" :props="{
                    title: $root.staticText.blog.successTitle,
                    text: $root.staticText.blog.successText}">
            </success-cmp>
        </transition>
        <transition name="fadeRight">
            <error-cmp v-if="infoForm.error" :props="{
                    title: $root.staticText.blog.errorTitle,
                    text: $root.staticText.blog.errorText}">
            </error-cmp>
        </transition>
        <transition name="fadeRight">
            <div v-show="!infoForm.success && !infoForm.error">
                <div class="t-title-bold t-form-comment__title" v-html="$root.staticText.blog.commentTitle"></div>
                <!-- Для незарегистрированных пользователей -->
                <!--        <div class="t-form-comment__container">-->
                <!--            <div class="t-form-comment__text" v-html="$root.staticText.blog.commentText"></div>-->
                <!--            <div class="t-form-comment__raw">-->
                <!--                <div class="t-btn _green _big" v-html="$root.staticText.blog.enterComment"></div>-->
                <!--                <div class="t-form-comment__reg" v-html="$root.staticText.blog.regComment"></div>-->
                <!--            </div>-->
                <!--        </div>-->
                <form class="t-form t-form-comment__form" @submit.stop.prevent="submitForm()" :class="{_disabled: infoForm.disabledForm}">
                    <div class="t-feedback__content">
                        <div
                            class="t-feedback__item"
                            :class="{_full: item.type === 'textarea'}"
                            v-for="(item, index) in form"
                        >
                            <div class="t-form__label">
                                {{ item.label }}
                                <span v-if="item.required">*</span>
                            </div>
                            <input
                                v-if="item.type === 'text'"
                                class="t-input"
                                :class="{'_error': item.error, '_valid': item.valid}"
                                :type="item.type"
                                :placeholder="item.placeholder"
                                v-model="item.value"
                                @focus="focusForm(index)"
                            >
                            <masked-input
                                v-if="item.type === 'phone'"
                                class="t-input"
                                :class="{'_error': item.error, '_valid': item.valid}"
                                mask="\+\7(111)111-11-11"
                                :placeholder="item.placeholder"
                                v-model="item.value"
                                :name="item.name"
                                @input="focusForm(index)"
                                :ref="index"/>
                            <textarea
                                v-if="item.type === 'textarea'"
                                class="t-textarea"
                                :placeholder="item.placeholder"
                                v-model="item.value"
                            >
                            </textarea>
                            <svg class="t-form__error-svg" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L9 9" stroke="white" stroke-width="2"/>
                                <path d="M9 1L1 9" stroke="white" stroke-width="2"/>
                            </svg>
                        </div>
                    </div>
                    <div
                        v-if="!$route.fullPath.includes('/lk')"
                        class="t-personal-data"
                        :class="{_error: infoForm.errorPersonalData}"
                    >
                        <input @change="changePersonalDataFrom()" type="checkbox"
                               id="personal-data" class="t-personal-data__input">
                        <label for="personal-data">
                            <svg width="16" height="12" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z" fill="white"/>
                            </svg>
                            {{$root.staticText.forms.agree}}
                            <a href="/user-agreement" target="_blank" class="t-personal-data__link">
                                {{$root.staticText.forms.personalData}}
                            </a>
                        </label>
                    </div>

                    <vue-recaptcha
                        ref="recaptcha"
                        size="invisible"
                        :sitekey="$root.sitekeyRecaptcha"
                        :load-recaptcha-script="true"
                        @verify="onCapchaRegister"
                        @expired="onCaptchaExpired"
                        @error="errorCaptcha"
                    />
                    <button class="t-btn _green t-form-comment__btn _big" v-html="$root.staticText.blog.commentTitle"></button>
                </form>
            </div>

        </transition>
    </div>
</template>

<script>
    import { validate, sendForm, changePersonalDataFrom, focusForm } from '@assets/js/formObjects.js';
    import success from '../../base/modals/success';
    import error from '../../base/modals/error';
    import VueRecaptcha from "vue-recaptcha";

    export default {
        name: "form-comment",
        props: {
            blogId: {
                type: String,
            }
        },
        data() {
            return {
                recaptchaToken: null,
                isValid: false,
                infoForm: {
                    action: 'blog/comment',
                    disabledForm: false,
                    isPersonalData: false,
                    errorPersonalData: false,
                    success: false,
                    error: false,
                    blogIdCmp: this.blogId
                },
                form: [
                    {
                        label: this.$root.staticText.forms.surname,
                        name: 'surname',
                        type: 'text',
                        value: '',
                        placeholder: this.$root.staticText.forms.placeholderSurname,
                        error: false,
                        valid: false,
                        required: true, // если параметр обязателен, то pattern должен быть не пустой, хотя бы на все символы (/\S{2,}/i)
                        pattern: /[a-zа-яё]{2,}/i
                    },
                    {
                        label: this.$root.staticText.forms.name,
                        name: 'name',
                        type: 'text',
                        value: '',
                        placeholder: this.$root.staticText.forms.placeholderName,
                        error: false,
                        valid: false,
                        required: true,
                        pattern: /[a-zа-яё]{2,}/
                    },
                    {
                        label: this.$root.staticText.forms.comment,
                        name: 'comment',
                        type: 'textarea',
                        value: '',
                        placeholder: this.$root.staticText.forms.placeholderComment,
                        error: false,
                        valid: false,
                        required: false,
                        pattern: ''
                    }
                ]
            }
        },
        components: {
            'success-cmp': success,
            'error-cmp': error,
            VueRecaptcha,
        },
        methods: {
            onCapchaRegister(recaptchaToken) {
                this.recaptchaToken = recaptchaToken;
                if (this.isValid) {
                    this.send();
                }
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset();
            },
            errorCaptcha() {
                console.log('errorCaptcha');
            },

            submitForm() {
                this.validate();

                if (this.isValid) {
                    this.$refs.recaptcha.execute();
                }
            },
            validate() {
                this.isValid = validate(this.form, this.infoForm, this.$route);
            },
            send() {
                return {...sendForm(this.form, this.infoForm, this.recaptchaToken)};
            },
            changePersonalDataFrom() {
                return {...changePersonalDataFrom(this.infoForm)};
            },
            focusForm(i) {
                return {...focusForm(this.form, i)};
            },
        }
    }
</script>

<style lang="sass">
    @import "../../../../sass/params"

    .t-form-comment
        margin: 72px 0 0
        padding: 56px 48px 48px
        border-radius: 6px
        background-color: #ffffff
        &__title
            margin-bottom: 24px
        &__text
            line-height: 150%
            margin-bottom: 40px
        &__raw
            display: flex
            align-items: center
        &__reg
            color: $gray-text
            padding-bottom: 5px
            border-bottom: 1px dashed $gray-text
            margin-left: 36px
            transition: all .2s
            cursor: pointer
            &:hover
                border-bottom: 1px dashed $green
                color: $green
        &__form
            margin-top: 40px
        &__btn
            margin-top: 32px

        @media screen and (min-width: $desktop-medium)
            padding: 64px 56px
            &__btn
                margin-top: 48px

        @media screen and (min-width: $desktop-big)
            margin: 80px 0 0
            padding: 72px 64px
            &__form
                margin-top: 48px
            &__btn
                margin-top: 56px

        @media screen and (max-width: $desktop-small)
            margin: 64px 0 0
            padding: 48px
            &__title
                font-size: 40px

        @media screen and (max-width: $tablet-size)
            &__form
                margin-top: 32px

        @media screen and (max-width: $mobile-size)
            margin: 48px 16px 0
            padding: 24px
            &__form
                margin-top: 24px
                .t-feedback__content
                    margin-bottom: 0
            &__btn
                margin-top: 24px

</style>


// WEBPACK FOOTER //
// src/templates/components/ui-components/form-comment/form-comment.vue